import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Sparkles, Zap, Gift } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import StarsBackground from '@/components/StarsBackground';

export default function AuthConfirmed() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen relative flex items-center justify-center p-4">
      <StarsBackground />
      
      <Card className="relative z-10 max-w-2xl w-full p-8 md:p-12 bg-background/95 backdrop-blur-lg border-primary/20">
        <div className="text-center space-y-6">
          {/* Success Icon */}
          <div className="flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/20 blur-2xl rounded-full animate-pulse" />
              <CheckCircle className="w-20 h-20 text-primary relative" />
            </div>
          </div>

          {/* Main Message */}
          <div className="space-y-2">
            <h1 className="text-4xl md:text-5xl font-bold text-gradient">
              Welcome to SOLR! ⚡
            </h1>
            <p className="text-xl text-muted-foreground">
              Your cosmic journey begins now
            </p>
          </div>

          {/* Confirmation Message */}
          <div className="bg-primary/10 border border-primary/20 rounded-lg p-6">
            <p className="text-lg">
              🎉 <strong>Email Confirmed!</strong> Your account is now fully activated.
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-3 gap-4 pt-4">
            <div className="bg-card/50 border border-border rounded-lg p-4 space-y-2">
              <Sparkles className="w-8 h-8 text-primary mx-auto" />
              <h3 className="font-semibold">Bronze Tier Active</h3>
              <p className="text-sm text-muted-foreground">
                Free shipping on orders over £50
              </p>
            </div>

            <div className="bg-card/50 border border-border rounded-lg p-4 space-y-2">
              <Zap className="w-8 h-8 text-primary mx-auto" />
              <h3 className="font-semibold">Earn Points</h3>
              <p className="text-sm text-muted-foreground">
                Every purchase = loyalty rewards
              </p>
            </div>

            <div className="bg-card/50 border border-border rounded-lg p-4 space-y-2">
              <Gift className="w-8 h-8 text-primary mx-auto" />
              <h3 className="font-semibold">Birthday Bonus</h3>
              <p className="text-sm text-muted-foreground">
                5% off during your birthday month
              </p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
            <Button size="lg" onClick={() => navigate('/shop')} className="text-lg">
              Start Shopping ⚡
            </Button>
            <Button size="lg" variant="outline" onClick={() => navigate('/dashboard')}>
              View Dashboard
            </Button>
          </div>

          {/* Auto-redirect Message */}
          <p className="text-sm text-muted-foreground">
            Redirecting to your dashboard in {countdown} second{countdown !== 1 ? 's' : ''}...
          </p>
        </div>
      </Card>
    </div>
  );
}
